import React from "react";
import CourseScore from "../CourseScore";
import CourseRulesMobile from "./CourseRulesMobile";

const Index = ({ tab }: { tab: string }) => {
    return (
        <div>
            {tab === "detail" && <CourseScore />}
            {tab === "rules" && <CourseRulesMobile />}
        </div>
    );
};

export default Index;
